var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flv"},[_c('video',{ref:"videoElement",attrs:{"controls":"","autoplay":"autoplay","muted":"muted","id":"videoElement"},domProps:{"muted":true}},[_c('source',{attrs:{"type":"video/mp4"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }